import {
    CUSTOMER_LOADING, CUSTOMER_SUCCESS,
    CUSTOMER_ERROR, RESET_CUSTOMER
} from "../actions/actionCustomer";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "Customers";

const initialState = {
    customer: loadState(sessionKey1, []),
    loading: false,
    customerError: ''
};

function reducerCustomer(state = initialState, action) {

    switch (action.type) {
        case CUSTOMER_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case CUSTOMER_SUCCESS: {

            saveState(sessionKey1, action.payload);

            return {
                ...state,
                customer: action.payload,
                loading: false,
                customerError: ''
            };
        }

        case CUSTOMER_ERROR: {

            return {
                ...state,
                customer: [],
                loading: false,
                customerError: action.error
            };
        }

        case RESET_CUSTOMER: {

            saveState(sessionKey1, []);

            return {
                ...state,
                loading: false,
                customer: [],
                customerError: ''
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerCustomer;